(function () {
    'use strict';
    angular.module('jcsfApp')
        .factory('principal', ['$http','$q',
        function principal($http,$q) {
            var theIdentity;
            var authenticated = false;
            return {
                isIdentityResolved: function () { return angular.isDefined(theIdentity); },
                isAuthenticated: function () { return authenticated; },
                isInRole: function (role) {
                    if (!authenticated || !theIdentity.roles) return false;
                    return theIdentity.roles.indexOf(role) !== -1;
                },
                isInAnyRole: function (roles) {
                    if (!authenticated || !theIdentity.roles) return false;

                    for (var i = 0; i < roles.length; i++) {
                        if (this.isInRole(roles[i])) return true;
                    }

                    return false;
                },
                authenticate: function (identity) {
                    theIdentity = identity;
                    authenticated = identity !== null;
                },
                identity: function (force) {
                    var deferred = $q.defer();
                    if (force === true) { theIdentity = undefined; }
                    if (angular.isDefined(theIdentity)) {
                        deferred.resolve(theIdentity);
                        return deferred.promise;
                    }
                    $http.get('/api/WS_Account/GetCurrentUserName')
                        .then(function (results) {
                            theIdentity = results.data.user;
                            authenticated = true;
                            deferred.resolve(theIdentity);
                        }).error(function () {
                            theIdentity = null;
                            authenticated = false;
                            deferred.resolve(theIdentity);
                        });
                    return deferred.promise;
                }
            };
        }
        ]);
})();